import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link, useParams } from "react-router-dom";
import { Users, Package, CreditCard, Activity, FileText, TrendingUp } from "lucide-react";

export default function CompanyReportsPage() {
  const { slug } = useParams();

  const reportCards = [
    {
      title: "Relatório de Usuários",
      description: "Análise de usuários, permissões e atividades",
      icon: Users,
      path: "users",
      color: "text-blue-500"
    },
    {
      title: "Relatório de Planos",
      description: "Uso de planos, renovações e histórico",
      icon: Package,
      path: "plans",
      color: "text-purple-500"
    },
    {
      title: "Relatório Financeiro",
      description: "Pagamentos, faturas, boletos e transações",
      icon: CreditCard,
      path: "financial",
      color: "text-green-500"
    },
    {
      title: "Relatório de Atividades",
      description: "Logs de auditoria e ações dos usuários",
      icon: Activity,
      path: "activities",
      color: "text-orange-500"
    },
    {
      title: "Relatório de Crescimento",
      description: "Novos usuários, sistemas ativados e métricas",
      icon: TrendingUp,
      path: "growth",
      color: "text-cyan-500"
    },
    {
      title: "Relatório Geral",
      description: "Visão completa de todos os dados da empresa",
      icon: FileText,
      path: "general",
      color: "text-indigo-500"
    }
  ];

  return (
    <div className="container mx-auto py-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Relatórios Administrativos</h1>
        <p className="text-muted-foreground mt-2">
          Análises e relatórios gerenciais da empresa
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reportCards.map((report) => {
          const Icon = report.icon;
          return (
            <Card key={report.path} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="flex items-center gap-3">
                  <div className={`p-2 rounded-lg bg-muted ${report.color}`}>
                    <Icon className="h-6 w-6" />
                  </div>
                  <CardTitle className="text-lg">{report.title}</CardTitle>
                </div>
                <CardDescription className="mt-2">
                  {report.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <Button asChild variant="outline" className="w-full">
                  <Link to={`/company/${slug}/admin/reports/${report.path}`}>
                    Ver Relatório
                  </Link>
                </Button>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
